module.exports = __webpack_public_path__ + "img/gerüstbohlen-möbel-tisch-kerstin.a61c8570.jpeg";